//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function () {
  angular
    .module('curalate')
    .component('universalImageActionsProductizeSearchBar', {
      bindings: {
        productSuggestionBoxId: '<',
        universalItemId: '@',
        productSearchCallback: '&',
        isCatalogConnected: '<',
        catalogClient: '<',
        catalogSelectorLoading: '<',
        isBvCampaignTagged: '<',
      },
      template: require('@legacy-components/common/universal-image-actions/universal-image-actions-productize-search-bar.html'),
      controller: [
        '$scope',
        '$element',
        '$timeout',
        'ErrorNotificationService',
        'ProductSearchService',
        'TrackingService',
        'UniversalImageActionsHelpers',
        'UniversalImageActionsApiService',
        'UniversalImageActionsService',
        'UniversalImageActionsTrackingService',
        function (
          $scope,
          $element,
          $timeout,
          ErrorNotificationService,
          ProductSearchService,
          TrackingService,
          UniversalImageActionsHelpers,
          UniversalImageActionsApiService,
          UniversalImageActionsService,
          UniversalImageActionsTrackingService,
        ) {
          const launchOptions =
            UniversalImageActionsService.getCurrentLaunchOptions();
          const currentPage = UniversalImageActionsService.getCurrentPage();
          const ERR_MISSING_CATALOG_CODE = 2;
          const ERR_GENERIC_SEARCH_MSG =
            'An error occurred while searching. Please try again.';
          const ERR_PRODUCT_SEARCH_TIMEOUT_CODE = 4;

          const TRACKING_CATEGORY =
            UniversalImageActionsHelpers.getTrackingCategory(currentPage);
          let productCatalogClientId = null;
          let productSearchRequest;
          let searchBarElement;

          const handleProductSearchResults = (data) => {
            UniversalImageActionsTrackingService.setQueryResults(data);
            ProductSearchService.handleSearchResults(data);

            if (
              data.length === 0 ||
              (data.length > 0 &&
                (!data[0].name || data[0].images.length === 0))
            ) {
              TrackingService.recordEvent(
                TRACKING_CATEGORY,
                TrackingService.ACTION_SEARCH,
                'empty',
              );
            } else if (data.length > 0) {
              TrackingService.recordEvent(
                TRACKING_CATEGORY,
                TrackingService.ACTION_SEARCH,
                data[0].searchSource,
              );
            }
          };

          const handleProductSearchError = (error) => {
            if (typeof error === 'object') {
              if (error && error.errorCode === ERR_MISSING_CATALOG_CODE) {
                ProductSearchService.handleNoCatalog();
                TrackingService.recordEvent(
                  TRACKING_CATEGORY,
                  TrackingService.ACTION_SEARCH_ERROR,
                  'invalid-query',
                );
              } else if (
                error &&
                error.errorCode === ERR_PRODUCT_SEARCH_TIMEOUT_CODE
              ) {
                // Treat as NO_RESULTS
                ProductSearchService.handleSearchResults([]);
                TrackingService.recordEvent(
                  TRACKING_CATEGORY,
                  TrackingService.ACTION_SEARCH_ERROR,
                  error.errorCode,
                );
              } else {
                ErrorNotificationService.showDefaultErrorDialog(
                  ERR_GENERIC_SEARCH_MSG,
                  error.errorId,
                );
                TrackingService.recordEvent(
                  TRACKING_CATEGORY,
                  TrackingService.ACTION_SEARCH_ERROR,
                  error.message,
                );
              }
            } else {
              ErrorNotificationService.showDefaultErrorDialog(
                ERR_GENERIC_SEARCH_MSG,
              );
              TrackingService.recordEvent(
                TRACKING_CATEGORY,
                TrackingService.ACTION_SEARCH_ERROR,
                error,
              );
            }
          };

          const handleEmptyQuery = () => {
            ProductSearchService.clearProductsState();
            if (this.isCatalogConnected === false) {
              ProductSearchService.handleNoCatalog();
            }
            if (this.universalItemId && this.productSuggestionBoxId) {
              ProductSearchService.getProductSuggestions(
                this.universalItemId,
                this.productSuggestionBoxId,
              );
            }
          };

          const focusSearchBar = () => {
            $timeout(() => {
              searchBarElement.trigger('focus');
            }, 0);
          };

          this.$onInit = () => {
            this.query = '';
            this.searchBarPlaceholder = 'Search by product name, SKU, or URL';
            this.isLoading = this.catalogSelectorLoading;
            handleEmptyQuery();
          };

          this.searchCatalog = () => {
            this.productSearchCallback();

            if (!this.query) {
              handleEmptyQuery();
              return;
            }

            this.outstandingAsyncAction = 'search';

            if (this.isBvCampaignTagged === undefined) {
              UniversalImageActionsService.getItemMetadataAsync().then(
                (metadata) => {
                  this.isBvCampaignTagged = metadata.isBvCampaignTagged;
                  this.performSearch();
                },
              );
            } else {
              this.performSearch();
            }
          };

          this.performSearch = () => {
            if (
              productSearchRequest &&
              productSearchRequest.abort !== undefined
            ) {
              productSearchRequest.abort();
            }

            const searchPromise = this.isBvCampaignTagged
              ? this.searchBvCatalog()
              : this.searchRegularCatalog();

            productSearchRequest = searchPromise
              .then((data) => {
                if (!(data && data.length > 0)) {
                  return;
                }
                // For content tagged with a BV Campaign, we only show BV Catalog products.
                // This is intentional, as we agreed to only tag BV Catalog products on BV Campaign content.
                if (this.isBvCampaignTagged) {
                  data = mapBvResponseToSoCoFormat(data);
                }
                handleProductSearchResults(data);
              })
              .catch((error) => {
                handleProductSearchError(error);
              })
              .finally(() => {
                this.outstandingAsyncAction = null;
                $scope.$applyAsync();
              });

            return productSearchRequest;
          };

          this.searchBvCatalog = () => {
            const params = {
              keywords: this.query,
            };
            UniversalImageActionsTrackingService.setQueryParams(params);
            return UniversalImageActionsApiService.searchBvCatalogProducts(
              params,
            ).then((response) => response.data.products);
          };

          this.searchRegularCatalog = () => {
            const params = {
              search: this.query,
              universalItemId: launchOptions.getUniversalItemId(),
              catalogClientId: productCatalogClientId,
            };
            UniversalImageActionsTrackingService.setQueryParams(params);
            return UniversalImageActionsApiService.searchProductsAsync(params);
          };

          this.$onChanges = (changesObj) => {
            if (changesObj.catalogClient) {
              if (changesObj.catalogClient.currentValue) {
                productCatalogClientId = this.catalogClient.client_id;
              } else {
                productCatalogClientId = null;
              }
            }
            if (
              changesObj.catalogSelectorLoading &&
              !changesObj.catalogSelectorLoading.currentValue
            ) {
              this.isLoading = false;
              focusSearchBar();
            }
          };

          this.$postLink = () => {
            searchBarElement = $element.find('.search-input-container input');
          };

          function mapBvResponseToSoCoFormat(bvProducts) {
            if (!Array.isArray(bvProducts) || bvProducts.length === 0) {
              return [];
            }

            const mappedProducts = bvProducts
              .filter(
                (bvProduct) =>
                  bvProduct.productDetailPageUrl &&
                  bvProduct.productDetailPageUrl !== '',
              )
              .map((bvProduct) => {
                return {
                  destinationUrl: bvProduct.productDetailPageUrl,
                  images: [
                    {
                      fileId: bvProduct.fileId,
                      imageUrl: bvProduct.imageUrl,
                      sourceImageUrl: bvProduct.imageUrl,
                    },
                  ],
                  name: bvProduct.name,
                  productStyleId: bvProduct.styleId,
                  styleId: bvProduct.styleId,
                  description: bvProduct.description,
                  externalId: bvProduct.samplingProductId,
                };
              });

            return mappedProducts;
          }
        },
      ],
    });
})();
